// extracted by mini-css-extract-plugin
module.exports = {"test":"Test_test_3Efcu","counter":"Test_counter_2VZVE","question":"Test_question_3V9DQ","answers":"Test_answers_33Gwc"};